import { SessionStorage } from "@stripe-internal/stripe-cookies";
import createSessionStorageEventListener from "./createSessionStorageEventListener";
const emptyConfig = {};
const configMap = new WeakMap();
export default function initSessionStorage(config, reports) {
    const potentialSessionStorageObj = configMap.get(config !== null && config !== void 0 ? config : emptyConfig);
    if (potentialSessionStorageObj) {
        return potentialSessionStorageObj;
    }
    const sessionStorage = new SessionStorage({
        enforcementMode: config === null || config === void 0 ? void 0 : config.enforcementMode
    });
    const eventListener = createSessionStorageEventListener(reports);
    const sessionStorageObj = {
        sessionStorage,
        eventListener
    };
    configMap.set(config !== null && config !== void 0 ? config : emptyConfig, sessionStorageObj);
    return sessionStorageObj;
}

//# sourceMappingURL=initSessionStorage.js.map